import React from "react";
import styles from "./style.scss";
import { Note } from "features/Note";

interface Props {
  question: string;
  questionOptimization?: string;
  questionAt?: string;
  onClickReEdit: (question: string) => void;
}

// ユーザ質問コンポーネント
export const UserQuestion: React.FC<Props> = ({
  question,
  questionOptimization,
  questionAt,
  onClickReEdit
}) => {
  // クリック後フォーカスを外す
  const handleClickReEdit = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClickReEdit(question);
    if (event.detail > 0) {
      event.currentTarget.blur();
    }
  };

  return (
    <div className={styles.userQuestion}>
      <div className={styles.actionTooltip}>
        <Note
          className={styles.note}
          content={
            <span className={styles.noteContent}>
              プロンプトを再利用して編集
            </span>
          }
          position="bottom"
        >
          <button
            type="button"
            className={styles.editBtn}
            aria-label="プロンプトを再利用して編集"
            onClick={handleClickReEdit}
          >
            <span className={styles.icon} />
          </button>
        </Note>
        <div className={styles.original}>{question}</div>
      </div>
      {questionOptimization && (
        <>
          <div className={styles.optimization}>
            <span className={styles.tips}>
              以下のように質問を最適化して回答します
            </span>
            <span className={styles.optimizationText}>
              {questionOptimization}
            </span>
          </div>
          <div className={styles.questionAt}>{questionAt}</div>
        </>
      )}
    </div>
  );
};
